// eslint-disable-next-line no-unused-vars
import React from 'react'
import { resolve } from 'styled-jsx/css'

export const section = resolve`
    margin: 0 0 10px;
`

export const sectionTitle = resolve`
    color: black;
    font-weight: bold;
    font-size: 1.3em;
    line-height: 2;
    margin: 0 0 10px;
`

export const container = resolve`
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;
`

export const inputWrapper = resolve`
    margin: 0;
    width: 100%;
`



// WEBPACK FOOTER //
// ./src/components/form/styles.js